<template>
  <div class="section">
    <img alt="Vue logo" src="@/assets/logo.png">
    <h1>Welcome to Mackenzie's personal site</h1>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
